export const blockIconsAudioandvideoSoundDetectionDogBarkingNew = (
	<span className='material-symbols-outlined'>sound_detection_dog_barking</span>
);
